"use strict";

const HOST_NAME = window.location.hostname;

const isChatboost = (HOST_NAME === 'chatboost-ec.dmm.com');

const wrapperTaget = document.getElementById('fn-dmm-common-navi-wrapper');
const naviWrapperTaget = document.getElementById('fn-dmm-common-navi');

const ENDPOINT_PC =
  "https://navismithapis.com/v1/com/pc/chatboostec?headers=logo,global&logo=chatboostec";
const ENDPOINT_SP =
  "https://navismithapis.com/v1/com/sp/chatboostec?headers=logo,global&logo=chatboostec";

const isMobile = function() {
  var ua = navigator.userAgent;
  // sp
  if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
    return true;
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
    // PC(tablet)
    return false;
  } else {
    // PC
    return false;
  }
};

const getQuery = function() {
  if (isMobile()) {
    return ENDPOINT_SP;
  }
  return ENDPOINT_PC;
};

const setScriptAttr = function(scripts) {
  let body = document.getElementsByTagName('body')[0];
  let scriptFragment = document.createDocumentFragment();
  let scriptTemplate = document.createElement('div');

  scriptTemplate.insertAdjacentHTML("afterbegin", scripts);
  for (let i = 0; i < scriptTemplate.childNodes.length; i++) {
    let org = scriptTemplate.childNodes[i];
    if (org.tagName !== 'SCRIPT') {
      continue;
    }
    let script = document.createElement('script');

    // set src
    if (org.src) {
      script.src = org.src;
    }

    // set id
    if(org.id) {
      script.id = org.id;
    }

    // set data-xxx
    if(Object.keys(org.dataset).length) {
      let datasetKeys = Object.keys(org.dataset);
      for(let j = 0; j <  datasetKeys.length; j++) {
        let dataKey = datasetKeys[j];
        script.dataset[dataKey] = org.dataset[dataKey];
      }
    }

    // set crossorigin
    if (org.crossOrigin) {
      script.crossOrigin = org.crossOrigin;
    }

    // set defer
    if (org.defer) {
      script.defer = org.defer;
    }

    // set javascript code
    if(org.innerHTML) {
      script.innerHTML = org.innerHTML;
    }

    // add script
    scriptFragment.appendChild(script);
  }
  // add all scripts
  body.appendChild(scriptFragment);
  scriptFragment.onload = showMenu();
};

const showMenu = function () {
  setTimeout(function () {
    $('._n4v1-header').css('visibility', 'visible');
  }, 800);
};

// Sample code
let url = getQuery();
let xhr = new XMLHttpRequest();
xhr.open('GET', url, true);
xhr.responseType = 'json';
xhr.onreadystatechange = function() {
  if (xhr.readyState !== 4) {
    return;
  }
  if (xhr.status !== 200) {
    return;
  }
  let head = document.getElementsByTagName('head')[0];
  let body = document.getElementsByTagName('body')[0];
  let res = xhr.response;

  // 1.css
  head.insertAdjacentHTML('beforeend', res.style);

  // 2.header
  naviWrapperTaget.insertAdjacentHTML('afterbegin', res.header);

  // 3.wrap
  if(res.main_contents.start) {
    let bodyChild = body.children;
    let main = wrapperTaget;
    let parser = new DOMParser();
    let mainContentsDomTree = parser.parseFromString(res.main_contents.start, 'text/html');
    let mainContents = mainContentsDomTree.getElementsByTagName('div')[0];
    body.insertBefore(
      mainContents,
      bodyChild[1]
    );
    mainContents.insertAdjacentElement('afterbegin', main);
  }

  // 4.footer
  body.insertAdjacentHTML('beforeend', res.footer);

  // 5.scripts
  setScriptAttr(res.scripts);
};

xhr.send();